export default __webpack_public_path__ + "0b9a7cdb8d60f2c21d7ce86545d62500.svg";